"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eExposureTempDesiredCoverage = exports.eExposureValuation = void 0;
const exposures_class_1 = __importDefault(require("./exposures.class"));
var eExposureValuation;
(function (eExposureValuation) {
    eExposureValuation["CIF10"] = "CIF +10%";
    eExposureValuation["CIF20"] = "CIF +20%";
    eExposureValuation["SELLING_PRICE"] = "Selling Price";
})(eExposureValuation = exports.eExposureValuation || (exports.eExposureValuation = {}));
var eExposureTempDesiredCoverage;
(function (eExposureTempDesiredCoverage) {
    eExposureTempDesiredCoverage["COMPLETE_DAY_BREAKDOWN"] = "24 hour breakdown";
    eExposureTempDesiredCoverage["HALF_DAY_BREAKDOWN"] = "12 Hour breakdown";
})(eExposureTempDesiredCoverage = exports.eExposureTempDesiredCoverage || (exports.eExposureTempDesiredCoverage = {}));
exports.default = exposures_class_1.default;
//# sourceMappingURL=index.js.map